import { COMMERCIAL_ENDPOINTS } from '../../../utils/api/endpoints/commercialEndpoints';
import {
  BoostsByMonthQueryResponse,
  UseBoostsByMonthQueryParams,
} from './useBoostsByMonth.types';

const PREFIX = '[allBoostsByMonthQuery]';

export const allBoostsByMonthQuery = async (params: UseBoostsByMonthQueryParams) => {
  console.log(PREFIX, `Fetching commissions...`);
  const response = await COMMERCIAL_ENDPOINTS.getAllBoostsByMonth(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received commissions.`);
  return json as BoostsByMonthQueryResponse;
};
